module.exports = __webpack_public_path__ + "media/images/folder-25433038.png";